// ─── NAV ACTIVA AL HACER SCROLL ───────────────────────────────
// Resalta el enlace de la sección visible. El handler de scroll se
// limita con requestAnimationFrame para no saturar el hilo.
(() => {
  "use strict";

  const sections = document.querySelectorAll("section[id]");
  const navAnchors = document.querySelectorAll(".nav-links a");
  if (!sections.length || !navAnchors.length) return;

  let ticking = false;

  const setActive = (id) => {
    navAnchors.forEach((anchor) => {
      anchor.classList.toggle("active", anchor.getAttribute("href") === `#${id}`);
    });
  };

  const update = () => {
    ticking = false;

    // Línea de detección justo debajo del nav fijo (64px).
    const line = window.scrollY + 100;
    let currentId = "";
    sections.forEach((section) => {
      if (line >= section.offsetTop) currentId = section.id;
    });

    // Al llegar al fondo, la última sección puede no alcanzar la línea
    // (la página "toca fondo" antes): forzamos la última como activa.
    const atBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 2;
    if (atBottom) currentId = sections[sections.length - 1].id;

    setActive(currentId);
  };

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      window.requestAnimationFrame(update);
      ticking = true;
    },
    { passive: true }
  );

  update(); // estado inicial al cargar
})();
